/**
 * <cod-gallery>
 * Product media gallery: click a thumbnail, or the prev/next arrows, to
 * crossfade to a different slide (looping at both ends).
 */
class CodGallery extends HTMLElement {
  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll('.cod-gallery__slide'));
    this.thumbs = Array.from(this.querySelectorAll('.cod-gallery__thumb'));
    this.prevButton = this.querySelector('[data-gallery-prev]');
    this.nextButton = this.querySelector('[data-gallery-next]');
    this.currentIndex = this.slides.findIndex((slide) => slide.classList.contains('is-active'));
    if (this.currentIndex < 0) this.currentIndex = 0;

    this.thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        this.showSlide(Number(thumb.dataset.thumbIndex));
      });
    });

    this.prevButton?.addEventListener('click', () => {
      this.showSlide(this.currentIndex - 1);
    });

    this.nextButton?.addEventListener('click', () => {
      this.showSlide(this.currentIndex + 1);
    });
  }

  showSlide(index) {
    const count = this.slides.length;
    if (count === 0) return;
    // Loop: -1 wraps to the last slide, count wraps back to the first.
    const normalizedIndex = ((index % count) + count) % count;

    this.currentIndex = normalizedIndex;
    this.slides.forEach((slide, i) => {
      slide.classList.toggle('is-active', i === normalizedIndex);
    });
    this.thumbs.forEach((thumb, i) => {
      thumb.classList.toggle('is-active', i === normalizedIndex);
    });
  }
}

if (!customElements.get('cod-gallery')) {
  customElements.define('cod-gallery', CodGallery);
}
